$(function() {
  lang = $('html').prop('lang');
  $('.select-block select').each(function() {
    var $this = $(this);

    $this.select2({
      minimumResultsForSearch: 10,
      language: lang
    });
  });

});